import * as React from 'react';

import { ErrorView } from '@app/Components/ErrorView/ErrorView';

type ErrorBoundaryState = {
    hasError: boolean;
    isDismissed: boolean;
    error: Error | null;
    componentStack: string | null;
};

type ErrorBoundaryProps = React.PropsWithChildren & {
    resetKey?: string;
    isClosable?: boolean;
};

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {

    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = {
            hasError: false,
            isDismissed: false,
            error: null,
            componentStack: null
        };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        this.setState({
            hasError: true,
            error: error,
            componentStack: errorInfo.componentStack || null
        });
    }

    componentDidUpdate(prevProps: ErrorBoundaryProps) {
        if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
            this.setState({ hasError: false, isDismissed: false, error: null, componentStack: null });
        }
    }

    render() {
        if (this.state.hasError) {
            if (this.state.isDismissed) return null;

            const onClose = this.props.isClosable ? this._dismiss : undefined;
            return <ErrorView error={this.state.error} componentStack={this.state.componentStack} onClose={onClose} />;
        }
        return this.props.children;
    }

    private _dismiss = () => {
        this.setState({ isDismissed: true });
    };
}

export default ErrorBoundary;
